import docsJanuary2019 from './2019-01-23';

export default {
    "2019-01-23": docsJanuary2019
};